import { AdMaterialSizeCardGroup, Button, FormContainer } from 'odc-shared/components';
import OdcInput from 'odc-shared/components/Input/odcInput';

import { CommPlatform } from '@src/api/generated/data-contracts';

import GetInTouchCard from './getInTouchCard';
import GetInTouchWaiting from './getInTouchWaiting';
import { useContactUs } from './useContactUs';

import './index.scss';

const helpTypeOptions = [
  {
    value: 'advertiser', sizeName: 'User Growth',
  },
  {
    value: 'publisher', sizeName: 'Monetization',
  },
];

const GetInTouch = () => {
  const {
    formData,
    loading,
    submitDisable,
    hasSubmitted,
    emailValidateHelper,
    appUrlValidateHelper,
    updateField,
    submitForm,
  } = useContactUs();

  const handleSubmit = () => {
    submitForm();
  };

  if (hasSubmitted) {
    return <GetInTouchWaiting />;
  }

  return (
    <div className="odc-page-get-in-touch">
      <div className="get-in-touch-flex">
        <GetInTouchCard />
        <div className="get-in-touch-form">
          <FormContainer
            label="Organization name"
            labelClassName="!mb-2r"
            className="!mb-4r"
          >
            <OdcInput
              placeholder="Enter organization name"
              className="size-lg has-bg"
              value={formData.orgName}
              onChange={(_, value) => {
                updateField('orgName', value);
              }}
              autoFocus
            />
          </FormContainer>
          <FormContainer
            label="Contact name"
            labelClassName="!mb-2r"
            className="!mb-4r"
          >
            <OdcInput
              placeholder="Enter contact name"
              className="size-lg has-bg"
              value={formData.contactName}
              onChange={(_, value) => {
                updateField('contactName', value);
              }}
            />
          </FormContainer>
          <FormContainer
            label="Email address"
            labelClassName="!mb-2r"
            className="!mb-4r"
            {...emailValidateHelper.validateProps}
          >
            <OdcInput
              placeholder="Enter email address"
              className="size-lg has-bg"
              value={formData.emailAddress}
              onChange={(_, value) => {
                updateField('emailAddress', value);
              }}
            />
          </FormContainer>
          <FormContainer
            label="App or website URL"
            labelClassName="!mb-2r"
            className="!mb-4r"
            {...appUrlValidateHelper.validateProps}
          >
            <OdcInput
              placeholder="Enter your App url or website"
              className="size-lg has-bg"
              value={formData.appUrl}
              onChange={(_, value) => {
                updateField('appUrl', value);
              }}
            />
          </FormContainer>
          <FormContainer
            label="What can we help you with?"
            labelClassName="!mb-2r"
            className="!mb-4r"
          >
            <AdMaterialSizeCardGroup
              data={helpTypeOptions}
              value={formData.helpType}
              multiple
              onChange={(value) => {
                updateField('helpType', value as CommPlatform[]);
              }}
            />
          </FormContainer>
          <Button
            type="primary"
            className="w-full !mt-10r"
            loading={loading}
            disabled={submitDisable}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch;